import type {ReactNode} from "react";

import {
  ClientIcon,
  ExpedientIcon,
  LeadIcon,
  MaterialIcon,
  OfferIcon,
  PersonsIcon,
  RepresentativeIcon,
  ServiceIcon,
  SupplierIcon,
} from "@project/icons-web";

import {routes} from "../../../bootstrap/router/routes";
import {routeMessages} from "../../../messages/routes.messages";

interface MessageDescriptor {
  id: string;
  defaultMessage?: string;
}

export interface NavigationPageItem {
  href: string;
  icon: ReactNode;
  labelDescriptor: MessageDescriptor;
}

export interface NavigationModuleItem {
  id: string;
  labelDescriptor: MessageDescriptor;
  pages: NavigationPageItem[];
}

export const navigationItems: NavigationModuleItem[] = [
  {
    id: "user-management",
    labelDescriptor: routeMessages.userManagement,
    pages: [
      {
        href: routes.usermanagement.users.home(),
        icon: <PersonsIcon className="size-5" />,
        labelDescriptor: routeMessages.users,
      },
    ],
  },
  {
    id: "sales",
    labelDescriptor: routeMessages.sales,
    pages: [
      {
        href: routes.sales.leads.home(),
        icon: <LeadIcon className="size-5" />,
        labelDescriptor: routeMessages.leads,
      },
      {
        href: routes.sales.clients.home(),
        icon: <ClientIcon className="size-5" />,
        labelDescriptor: routeMessages.clients,
      },
      {
        href: routes.sales.representatives.home(),
        icon: <RepresentativeIcon className="size-5" />,
        labelDescriptor: routeMessages.representatives,
      },
      {
        href: routes.sales.expedients.home(),
        icon: <ExpedientIcon className="size-5" />,
        labelDescriptor: routeMessages.expedients,
      },
      {
        href: routes.sales.offers.home(),
        icon: <OfferIcon className="size-5" />,
        labelDescriptor: routeMessages.offers,
      },
    ],
  },
  {
    id: "engineering",
    labelDescriptor: routeMessages.engineering,
    pages: [
      {
        href: routes.engineering.suppliers.home(),
        icon: <SupplierIcon className="size-5" />,
        labelDescriptor: routeMessages.suppliers,
      },
      {
        href: routes.engineering.materials.home(),
        icon: <MaterialIcon className="size-5" />,
        labelDescriptor: routeMessages.materials,
      },
      {
        href: routes.engineering.services.home(),
        icon: <ServiceIcon className="size-5" />,
        labelDescriptor: routeMessages.services,
      },
    ],
  },
];
